/** Barrel dos configs de cadastro + lista para registrar rotas (lista/new/:uuid). */
import type { ResourceConfig } from '../config'
import { customersConfig, usuariosConfig, cargosConfig, placesConfig, personnelConfig, fleetConfig, assetsConfig, feriadosConfig } from './gestao'
import { fleetCategoriesConfig, personnelCategoriesConfig, placeCategoriesConfig, assetCategoriesConfig, modalityCategoriesConfig, naoAtendidoMotivosConfig, statusConfig } from './categorias'
import { duplasConfig, caminhoesConfig, caminhoes2ReboquesConfig, maquinariosConfig, utilitariosConfig } from './conjuntos'

export * from './gestao'
export * from './categorias'
export * from './conjuntos'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyConfig = ResourceConfig<any>

/** Usuários e Cargos, itens próprios do Administrativo desde 24/10/2026. A lista de
 *  Usuários fica no config; o criar e editar têm tela própria. */
export const ACESSO_CONFIGS: AnyConfig[] = [usuariosConfig, cargosConfig]

/** Os cadastros gerais, que todas as áreas usam como seletor. Moraram no
 *  Administrativo de 24/10 a 26/10/2026 e voltaram para o hub da Logística a pedido
 *  do Samuel. Ordem = ordem da nav interna do hub, em src/areas/logistica/cadastros.ts. */
export const CADASTROS_GERAIS_CONFIGS: AnyConfig[] = [
  customersConfig,
  personnelConfig,
  fleetConfig,
  placesConfig,
  assetsConfig,
  feriadosConfig,
]

/** Abas config-driven do hub de Cadastros da Logística. As outras abas dele, como
 *  Contratos e Serviços, têm grade própria. Duplas mora aqui desde 04/09/2026 (Samuel). */
export const CADASTROS_LOGISTICA_CONFIGS: AnyConfig[] = [duplasConfig]

/** Cadastros do hub "Categorias" (catálogos de tipo/classificação + Status). */
export const CATEGORIAS_CONFIGS: AnyConfig[] = [
  fleetCategoriesConfig,
  personnelCategoriesConfig,
  placeCategoriesConfig,
  assetCategoriesConfig,
  modalityCategoriesConfig,
  naoAtendidoMotivosConfig,
  statusConfig,
]

/** As três abas da tela Conjuntos (04/09/2026): Caminhões, Máquinas e
 *  Utilitários, nessa ordem. Listas como filhas da página de abas; os
 *  formulários seguem em tela cheia. */
export const CONJUNTOS_CONFIGS: AnyConfig[] = [
  caminhoesConfig,
  maquinariosConfig,
  utilitariosConfig,
  // A quarta aba (08/10/2026): os Caminhões de duas carretas.
  caminhoes2ReboquesConfig,
]

/** Todos os cadastros config-driven. Uma entrada = 2 rotas de form (`/new`, `/:uuid`). */
export const RESOURCE_CONFIGS: AnyConfig[] = [
  ...ACESSO_CONFIGS,
  ...CADASTROS_GERAIS_CONFIGS,
  ...CADASTROS_LOGISTICA_CONFIGS,
  ...CONJUNTOS_CONFIGS,
  ...CATEGORIAS_CONFIGS,
]

/** Configs cujo criar/editar tem TELA PRÓPRIA. A lista continua no
 *  ResourceListPage; só as rotas `/new` e `/:uuid` saem do registro genérico.
 *  Filtrar por aqui, em vez de confiar na ordem do JSX, importa: o React Router
 *  v6 ranqueia por especificidade, e dois caminhos iguais virariam sorteio. */
export const CUSTOM_FORM_BASE_PATHS = new Set<string>([
  '/administrativo/usuarios',
  '/portal/usuarios',
])
